var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMic = function SvgMic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-224.000000, -120.000000)",
    fill: "#151B22",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210,112.631579 C211.778571,112.631579 213.203571,111.221053 213.203571,109.473684 L213.214286,103.157895 C213.214286,101.410526 211.778571,100 210,100 C208.221429,100 206.785714,101.410526 206.785714,103.157895 L206.785714,109.473684 C206.785714,111.221053 208.221429,112.631579 210,112.631579 Z M215.678571,109.473684 C215.678571,112.631579 212.957143,114.842105 210,114.842105 C207.042857,114.842105 204.321429,112.631579 204.321429,109.473684 L202.5,109.473684 C202.5,113.063158 205.414286,116.031579 208.928571,116.547368 L208.928571,120 L211.071429,120 L211.071429,116.547368 C214.585714,116.042105 217.5,113.073684 217.5,109.473684 L215.678571,109.473684 Z",
    id: "Mic-on"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mic.4684939a.svg";
export { ForwardRef as ReactComponent };